<template>
  <v-app>
    <v-app-bar app color="#FFFFFF" prominent>
      <v-spacer />
      <div class="d-flex align-center">
        <v-img
          alt="bioMerieux Logo"
          src="/bm-logo-rgb.ai.png"
          width="180"
          position="top center"
          contain
          dense
        />
      </div>
      <v-spacer />
    </v-app-bar>
    <v-main>
      <router-view></router-view>
    </v-main>
    <v-footer padless>
      <v-col
        class="text-right grey--text"
        cols="12"
      >
        <strong>Customer Remote Solution</strong> — Version {{version}}
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
import { version } from '../package.json';

export default {
  name: "App",
  data: () => ({
    version 
  }),
  
};
</script>
<style lang="scss">
.v-application {
  font-family: Arial, sans-serif;
  .title {
    font-family: Arial, sans-serif;
  }
}
</style>